import * as types from "../types";

export const otpRequest = ({otpReq}) => ({
    type: types.OTP_REQUEST,
    payload:{
        otpReq
    }
})

export const otpSuccess = ({otpResult}) => ({
    type: types.OTP_SUCCESS,
    payload:{
        otpResult
    }
})

export const otpFailure = ({error}) => ({
    type: types.OTP_FAILURE,
    payload:{
        error: error.message
    }
})

export const otpReset = () => ({
    type: types.OTP_RESET
})
